import Vue from 'vue';
import Vuesax from 'vuesax';
import './plugins/axios';
import App from './App.vue';
import router from './router/index';
import child from './child';
import vuexI18n from 'vuex-i18n/dist/vuex-i18n.umd.js';
import VueLazyload from 'vue-lazyload';
import { i18n } from './localization/i18n';
import { store } from './store/store';
import { TypesPlugin } from './plugins/types';
import { UtilsPlugin } from './plugins/utils';
import VueKindergarten from 'vue-kindergarten';
import * as VueDeepSet from 'vue-deepset';
import Vuelidate from 'vuelidate';
import Multiselect from 'vue-multiselect';
import AsyncComputed from 'vue-async-computed';
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import VueSocketIO from 'vue-socket.io-extended';
import socket from 'socket.io-client';
import VModal from 'vue-js-modal';
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'vuesax/dist/vuesax.css';
import 'material-icons/iconfont/material-icons.css';
import browserDetect from "vue-browser-detect-plugin";

library.add(faCoffee);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import { guardShow, guardHide} from '@/directives/guard.vue';
Vue.directive('guardShow', guardShow);
Vue.directive('guardHide', guardHide);

import Guard from '@/components/Auth/Guards/Guard.vue'
Vue.component('Guard', Guard);

//Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);
Vue.use(ElementUI);

let config = {
    baseURL: process.env.VUE_APP_LOCATION
};

Vue.use(browserDetect);

Vue.use(VueSocketIO, socket(config.baseURL, { path: '/communicator/communicator' }), { store });
//Vue.use(VueSocketIO, socket('https://qa.printcube.app', { path: '/communicator/communicator' }), { store });

Vue.use(VueBreadcrumbs);
//provides $TYPES for Vue instance
Vue.use(TypesPlugin);

//provides $utils for Vue instance
Vue.use(UtilsPlugin);

//DeepSet https://github.com/bhoriuchi/vue-deepset
Vue.use(VueDeepSet);

// Vue form validation plugin
// https://github.com/monterail/vuelidate
Vue.use(Vuelidate);

//Provides async computed option for components
// https://github.com/foxbenjaminfox/vue-async-computed
Vue.use(AsyncComputed);

// Vue localization plugin
// https://github.com/dkfbasel/vuex-i18n
Vue.use(vuexI18n.plugin, store);

Vue.component('multiselect', Multiselect);
// Vue image lazyloading plugin
// https://www.npmjs.com/package/vue-lazyload
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '/static/images/error-image.jpg',
    loading: '/static/images/loading-image.jpg',
    attempt: 1,
    listenEvents: ['scroll', 'mousewheel', 'touchmove']
});

Vue.directive('init', {
    bind: function (el, binding, vnode) {

        // convert kebab-case to camelCase
        let arg = binding.arg.split('-').map((arg, index) => {
            return (index > 0) ? arg[0].toUpperCase() + arg.substring(1) : arg;
        }).join('');

        vnode.context[arg] = binding.value;
    }
});

/* eslint-disable */
/*Vue.config.errorHandler = function (err, vm, info) {
    console.log('VUE ERROR: ', err);
    console.log('VUE vm: ', vm);
    console.log('VUE INFO: ', info);
};

Vue.config.warnHandler = function (msg, vm, trace) {
    console.log('VUE ERROR: ', msg);
    console.log('VUE vm: ', vm);
    console.log('VUE INFO: ', trace);
};*/
/* eslint-enable */


// add translations directly to the application
Vue.i18n.add('en', i18n.en);
Vue.i18n.add('de', i18n.de);

// set the start locale to use
Vue.i18n.set('en');
Vue.i18n.fallback('en');
// set root url for http requests
// eslint-disable-next-line


// Vue Kindergarten
// https://github.com/JiriChara/vue-kindergarten
Vue.use(VueKindergarten, {
    // Getter of your current user.
    // If you use vuex, then store will be passed
    child
});

new Vue({
    router,
    store,
    render: h => h(App),
    sockets: {
        connect: function () {
            this.$socket.client.emit('panel');
        }
    }
}).$mount('#app');
